import { OK } from "helpers/data-statuses"
import { decimalToPercent } from "./configuration"

export interface GoalValue {
  inputValue: string | undefined
  displayValue: string
}

export function computeGoalValue(value: number | undefined, status: string): GoalValue {
  if (status !== OK || value === undefined) {
    return { inputValue: undefined, displayValue: "-" }
  }

  const percentValue = decimalToPercent(value)
  return { inputValue: percentValue, displayValue: percentValue }
}
